export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/environments/environment.ts